import React from 'react';
import { AbsoluteFill, Sequence, Audio, staticFile, interpolate, useCurrentFrame } from 'remotion';
import { SCENES, COLORS, TOTAL_DURATION } from './constants';

import { IntroScene } from './scenes/IntroScene';
import { ProblemScene } from './scenes/ProblemScene';
import { HeroScene } from './scenes/HeroScene';
import { FeaturesScene } from './scenes/FeaturesScene';
import { AIScene } from './scenes/AIScene';
import { AnalyticsScene } from './scenes/AnalyticsScene';
import { MonitorScene } from './scenes/MonitorScene';
import { IntegrationsScene } from './scenes/IntegrationsScene';
import { CTAScene } from './scenes/CTAScene';
import { OutroScene } from './scenes/OutroScene';

const ND = 12; // Narration delay frames

// Audio clips con duración en frames (segundos × 30)
const clips = [
  { key: 'PROBLEM', file: 'audio/scenes/02-problem.mp3', dur: 361 },
  { key: 'HERO', file: 'audio/scenes/03-hero.mp3', dur: 132 },
  { key: 'FEATURES', file: 'audio/scenes/04-features.mp3', dur: 253 },
  { key: 'AI', file: 'audio/scenes/05-ai.mp3', dur: 335 },
  { key: 'ANALYTICS', file: 'audio/scenes/06-analytics.mp3', dur: 419 },
  { key: 'MONITOR', file: 'audio/scenes/07-monitor.mp3', dur: 365 },
  { key: 'INTEGRATIONS', file: 'audio/scenes/08-integrations.mp3', dur: 221 },
  { key: 'CTA', file: 'audio/scenes/09-cta.mp3', dur: 71 },
] as const;

export const PrixiaVideo: React.FC = () => {
  const frame = useCurrentFrame();

  const musicVol = interpolate(
    frame,
    [0, 45, TOTAL_DURATION - 90, TOTAL_DURATION],
    [0, 0.14, 0.14, 0],
    { extrapolateRight: 'clamp', extrapolateLeft: 'clamp' }
  );

  return (
    <AbsoluteFill style={{ background: COLORS.bg }}>
      <Audio src={staticFile('audio/background-music.mp3')} volume={musicVol} />

      {clips.map(({ key, file, dur }) => {
        const s = SCENES[key as keyof typeof SCENES];
        return (
          <Sequence key={key} from={s.from + ND} durationInFrames={dur}>
            <Audio src={staticFile(file)} volume={0.95} />
          </Sequence>
        );
      })}

      <Sequence from={SCENES.INTRO.from} durationInFrames={SCENES.INTRO.duration}>
        <IntroScene />
      </Sequence>
      <Sequence from={SCENES.PROBLEM.from} durationInFrames={SCENES.PROBLEM.duration}>
        <ProblemScene />
      </Sequence>
      <Sequence from={SCENES.HERO.from} durationInFrames={SCENES.HERO.duration}>
        <HeroScene />
      </Sequence>
      <Sequence from={SCENES.FEATURES.from} durationInFrames={SCENES.FEATURES.duration}>
        <FeaturesScene />
      </Sequence>
      <Sequence from={SCENES.AI.from} durationInFrames={SCENES.AI.duration}>
        <AIScene />
      </Sequence>
      <Sequence from={SCENES.ANALYTICS.from} durationInFrames={SCENES.ANALYTICS.duration}>
        <AnalyticsScene />
      </Sequence>
      <Sequence from={SCENES.MONITOR.from} durationInFrames={SCENES.MONITOR.duration}>
        <MonitorScene />
      </Sequence>
      <Sequence from={SCENES.INTEGRATIONS.from} durationInFrames={SCENES.INTEGRATIONS.duration}>
        <IntegrationsScene />
      </Sequence>
      <Sequence from={SCENES.CTA.from} durationInFrames={SCENES.CTA.duration}>
        <CTAScene />
      </Sequence>
      <Sequence from={SCENES.OUTRO.from} durationInFrames={SCENES.OUTRO.duration}>
        <OutroScene />
      </Sequence>
    </AbsoluteFill>
  );
};
